import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/everything", { replace: true });
  }, [user, loading, navigate]);

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/everything";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen relative overflow-hidden grid place-items-center">
      <div className="orb orb-purple" style={{ width: 700, height: 700, top: -200, left: -200 }} />
      <div className="orb orb-orange" style={{ width: 600, height: 600, bottom: -200, right: -200, opacity: 0.35 }} />

      <div className="relative z-10 text-center px-8 max-w-lg">
        <div className="flex justify-center mb-8" data-testid="login-logo">
          <div className="w-3 h-3 rounded-full bg-[--orange]" style={{ background: "var(--orange)" }} />
        </div>
        <h1 className="serif-italic text-5xl md:text-6xl leading-tight mb-6" data-testid="login-title">
          Your mind, organised.
        </h1>
        <p className="text-white/60 mb-10 text-base leading-relaxed">
          A calm home for your notes, ideas, tasks, habits and focus. Capture anything.
          Organise nothing. Rediscover everything.
        </p>
        <button
          onClick={handleGoogle}
          data-testid="google-login-button"
          className="pill pill-orange px-6 py-3 text-sm tracking-wide uppercase"
          style={{ background: "var(--orange)", borderColor: "var(--orange)" }}
        >
          <span className="pill-dot" style={{ background: "#fff" }} />
          Continue with Google
        </button>
        <p className="text-xs text-white/40 mt-8">Secure Google sign-in · No password to remember</p>
      </div>
    </div>
  );
}
